
import React, { useEffect } from 'react';
import './landingPageStyle.css';
import { IoIosArrowRoundDown } from 'react-icons/io';
import clbs from './landing-images/clbs.jpg';
import secureme from './landing-images/secureme.png';
import locationPin from './landing-images/locationPin2.png';
import ogaApp from './landing-images/ogaApp.png';
// import Typed from "react-typed";
import AOS from 'aos';
import 'aos/dist/aos.css';
import LandingHeader from './landing-header/LandingHeader';
// import Slider from "./slider/Slider";

const LandingPage = () => {
  const baseUrl = ''
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <>
      <LandingHeader />
      <div className="hero-sectionTxt" id="hero">
        {/* <div className='side-img'>
        <Slider/>
      </div>
      <div className='hero-bolb' />
      <div className='hero-text'>
        <h1 className='text'>VITEL <span className='edd'>WIRELESS</span> LIMITED</h1>
       <Typed
       strings={[

        "<h2> UNIFYING COMMUNICATION USING </h2>"
       ]}

       typeSpeed={150}
       backSpeed={100}
       loop
       />
       <p className='gsm'>GSM Numbers + VoIP + IoT + VAS</p>

       <p className='info'><span>to provide telecommunication services,<br/>software development,sales and installation  of computers and accessories inclusive of wireless communications
        accessories.</span></p>

       <div className='circle2'>
        <p>
        Get Connected
        </p>

      </div>

      <button className='span1'>Sign up</button>
      <button className='span2'>Register</button>


      </div> */}

        <div className="content_hero">
          <h1 className="tourTech">
            <span className="limited">VITEL WIRELESS</span> LIMITED{' '}
          </h1>
          <p>
            Navigate with precision, connect seamlessly. Vitel Wireless delivers
            location-based solutions that transform your business.
          </p>
          <a href="#" className="cta-button">
            Get Started
          </a>
          <div class="vertical-line"/>
        </div>

        <div
          className="parentDivArrow"
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
        >
          <div className="divArrow">
            <IoIosArrowRoundDown />
          </div>
        </div>
        <div className="hero-background">
          {/* <img src={worldmap} alt='' className='heroBackImage' /> */}
          <img
            src={locationPin}
            alt=""
            className="heroBackImageSecon"
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="500"
          />
        </div>

        <div className="services">
          <div className="sectionName">services</div>
          <div className="parentServices">
            <div
              className="ogaBoizMain"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="1500"
            >
              <a href={`/secureme-app`}>
                <div className="ogaBoiz">
                  <img src={secureme} alt="" />
                </div>
                SECURE ME
              </a>
            </div>
            <div
              className="ogaBoizMain"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="3000"
            >
              <a href={`/oga-app`}>
                <div className="ogaBoiz">
                  <img src={ogaApp} alt="" />
                </div>
                OGA APP
              </a>
            </div>
            <div
              className="ogaBoizMain"
              data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="4500"
            >
              <a href={`/login`}>
                <div className="ogaBoiz">
                  <img src={clbs}  alt="hhhh"/>
                </div>
                CLBS
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
